
// First Form Books
import writersChoice from '../../../../src/assets/Images/TextBooks/FirstForm/WritersChoice.jpg';
import englishAlive from '../../../assets/Images/TextBooks/FirstForm/EnglishAlive.jpg'
import bridge from '../../../assets/Images/TextBooks/FirstForm/BridgeTerebithia.jpg';
import raisinInTheSun from '../../../assets/Images/TextBooks/FirstForm/RaisinSun.jpg';
import alchemyWords from '../../../assets/Images/TextBooks/FirstForm/AlchemyWords.jpg';

// Second Form Books
import englishAlive2 from '../../../assets/Images/TextBooks/SecondForm/EnglishAlive2.jpeg';
import homelessBird from '../../../assets/Images/TextBooks/SecondForm/HomelessBird.jpeg';
import writerChoice from '../../../assets/Images/TextBooks/SecondForm/WriterChoice.jpg';
import bekaLamb from '../../../assets/Images/TextBooks/SecondForm/BekaLamb.jpeg';
import juliusCaesar from '../../../assets/Images/TextBooks/SecondForm/JuliusCaesar.jpeg';

// Third Form Books
import beowulf from '../../../assets/Images/TextBooks/ThirdForm/Beowulf.jpeg';
import canterburyTales from '../../../assets/Images/TextBooks/ThirdForm/CanterburyTales.jpeg';
import lionAndJewel from '../../../assets/Images/TextBooks/ThirdForm/LionAndJewel.jpeg';
import literature from '../../../assets/Images/TextBooks/ThirdForm/Literature.jpeg';
import writersChoice3 from '../../../assets/Images/TextBooks/ThirdForm/WritersChoice3.webp';

// Fourth Form Books
import englishACSEC from '../../../assets/Images/TextBooks/FourthForm/EnglishACSEC.jpeg';
import livelyWriting from '../../../assets/Images/TextBooks/FourthForm/LivelyWriting.jpeg';
import practiceCSEC from '../../../assets/Images/TextBooks/FourthForm/PracticeCSEC.jpeg';
import prayersForToday from '../../../assets/Images/TextBooks/FourthForm/Prayers4Today.jpeg';
import breathEyesMemory from '../../../assets/Images/TextBooks/FourthForm/BreathEyesMemory.webp';

// French Books (Images)
import frenchPic1 from '../../../assets/Images/French/pic1.jpeg';
import frenchPic3 from '../../../assets/Images/French/pic3.jpeg';
import frenchPic4 from '../../../assets/Images/French/pic4.jpeg';
import frenchPic6 from '../../../assets/Images/French/pic6.jpeg';


export const firstFormTextBooks = [
  {id: '1WCB', bookImage: writersChoice},
  {id: '1EAB', bookImage: englishAlive},
  {id: '1BTB', bookImage: bridge},
  {id: '1RITS', bookImage: raisinInTheSun},
  {id: '1AWB', bookImage: alchemyWords},
];

export const secondFormTextBooks = [
  {id: '2EAB', bookImage: englishAlive2},
  {id: '2HLB', bookImage: homelessBird},
  {id: '2WCB', bookImage: writerChoice},
  {id: '2BLB', bookImage: bekaLamb},
  {id: '2JCB', bookImage: juliusCaesar},
]

export const thirdFormTextBooks = [
  {id: '3BOW', bookImage: beowulf},
  {id: '3CBTB', bookImage: canterburyTales},
  {id: '3LAJB', bookImage: lionAndJewel},
  {id: '3LTB', bookImage: literature},
  {id: '3WCB', bookImage: writersChoice3},
]

export const fourthFormTextBooks = [
  {id: '4LAOW', bookImage: livelyWriting},
  {id: '4EA4C', bookImage: englishACSEC},
  {id: '4PE4C', bookImage: practiceCSEC},
  {id: '4PFTD', bookImage: prayersForToday},
  {id: '4BEYM', bookImage: breathEyesMemory},
]

export const frenchTextBooks = [
  {id: '1FFP', bookImage: frenchPic1},
  {id: '1FTP', bookImage: frenchPic3},
  {id: '1FFOP', bookImage: frenchPic4},
  {id: '1FSIP', bookImage: frenchPic6},
]
